<template>
    <div class="regicall-follow-up-container">

        <!-- Loader -->
        <div class="loader-container"
            v-if="!loaded">
            <page-loader :loading="!loaded"></page-loader>
        </div>

        <!-- Content  -->
        <div v-if="loaded"
             class="columns">

            <!-- More calls in current active schedule -->
            <div v-if="call.is_finished && nextPlannedCall" class="box has-background-blue has-text-white column is-8 is-offset-1">
                <div class="has-text-centered"><i class="far fa-comment fa-4x has-text-white"></i></div>

                <div v-if="call.is_successful" class="has-text-centered has-text-size-20 has-text-weight-bold">Bedankt voor het bellen met {{call.client.title}} {{call.client.name}}!</div>
                <div v-else class="has-text-centered has-text-size-20 has-text-weight-bold">Bedankt voor je inzet! Volgende keer beter.</div>

                <div class="has-text-centered">Wat wil je nu doen?</div>
                <div class="has-text-centered">
                  <a class="button m-1" @click="goToNextCall">De volgende bellen</a>
                  <a class="button m-1" @click="goToOverview">Terug naar het overzicht</a>
                </div>
            </div>

            <!-- No more calls in current active schedule -->
            <div v-if="!nextPlannedCall" class="box has-background-blue has-text-white column is-8 is-offset-1">
                <div class="has-text-centered"><i class="far fa-comment fa-4x has-text-white"></i></div>
                <div class="has-text-centered has-text-size-20 has-text-weight-bold">Je bent klaar met de bellijst!</div>
                <div class="has-text-centered"><i class="fas fa-heart"></i> Hartelijk dank voor het bellen vandaag! <i class="fas fa-heart"></i></div>
                <div class="has-text-centered">
                    <a class="button m-1" @click="goToOverview">Terug naar het overzicht</a>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
  import { Call } from '../../../models/Call';
  import { Client } from '../../../models/Client';
  import { Schedule } from '../../../models/Schedule';

  import { Info as OverviewInfo } from '../containers/Overview';
  import { Info as CallInfo } from '../containers/Call';

  import PageLoader from '../../../components/PageLoader';

  export const Info = {
    name: 'Vervolg',
    path: 'vervolg/:id',
    props: true,
    hideInNav: true
  };

  export default {
    Info,
    components: { PageLoader },
    async created () {
      await this.loadData();
    },
    data () {
      return {
        title: Info.name
      };
    },
    computed: {
      callId () {
        return this.$route.params.id;
      },
      loaded () {
        return !!this.call && !!this.client && !!this.schedule;
      },
      call () {
        return Call.query().withAll().find(this.callId);
      },
      client () {
        return this.call.client;
      },
      schedule () {
        return Schedule.query().withAllRecursive().where('active', true).first();
      },
      nextPlannedCall () {
        return this.schedule.callItems.filter((call) => {
          return !call.is_finished;
        })[0];
      }
    },
    methods: {
      async loadData () {
        if (!this.schedule) {
          await Schedule.loadActiveSchedule();
        }
        if (!this.call) {
          await Call.load(this.callId);
        }
        if (!this.client) {
          await Client.load(this.call.client_id);
        }
      },
      goToOverview () {
        this.$router.push({ name: OverviewInfo.name });
      },
      goToCall (id) {
        this.$router.push({ name: CallInfo.name, params: { id }});
      },
      goToNextCall () {
        this.goToCall(this.nextPlannedCall.id);
      },
      goToExtraCall () {
        alert('Werk in uitvoering');
      }
    }
  };
</script>
